/* @flow */
import React from 'react';
import cx from 'classnames';
import { getPropClassesFromInstance } from 'lib/getPropClasses';

import './styles/Copy.scss';

/**
 * Copy is a component for applying base typography styles to elements containing text, such as
 * headings, paragraphs & lists
 *
 * ```example
 *  <Copy>
 *    <p>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
 *     commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
 *    </p>
 *    <p>
 *     Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean eget rhoncus nunc, eget
 *     commodo felis. Vestibulum mattis mi tortor, id imperdiet ex imperdiet in.
 *    </p>
 *    <ol>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *    </ol>
 *    <ul>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *      <li>Lorem ipsum dolor sit amet</li>
 *    </ul>
 *  </Copy>
 * ```
 */

export default class extends React.Component {
  static propTypes = {
    center: React.PropTypes.bool,
    color: React.PropTypes.oneOf(['pitch', 'thunder']),
    size: React.PropTypes.oneOf(['medium']),
  };

  static propClasses = {
    center: 'Copy--center',
    color: {
      pitch: 'Copy--pitch',
      thunder: 'Copy--thunder',
    },
    size: {
      medium: 'Copy--medium',
    },
  };

  static defaultProps = {
    center: false,
    color: 'pitch',
    size: 'medium',
  };

  render() {
    return (
      <div className={cx('Copy', getPropClassesFromInstance(this), this.props.className)}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Copy.jsx